import { Children, cloneElement, FC, ReactElement, ReactNode, useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import KeenSlider, { TOptions } from 'keen-slider';
import { useKeenSlider } from 'keen-slider/react';
import { keenStyles } from './styles/keenStyles';
export interface CbCarouselTrackProps {
  fillTrack?: boolean;
  isFullView?: boolean;
  options?: TOptions;
  overrideStyles?: string;
  getSlider?: (slider: KeenSlider) => void;
  children?: ReactNode;
}
export const CbCarouselTrack: FC<CbCarouselTrackProps> = ({
  fillTrack,
  isFullView = false,
  options = {},
  overrideStyles = '',
  getSlider,
  children
}) => {
  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>(options);
  const [fillerSlides, setFillerSlides] = useState<JSX.Element[]>([]);
  const arrayChildren = Children.toArray(children);
  const wrappedChildren = Children.map(arrayChildren, (child: ReactElement) => {
    return <Box className="keen-slider__slide">{cloneElement(child)}</Box>;
  });
  const fillSlides = (difference: number) => {
    const slidesArray = new Array(difference).fill('').map((_, index) => <Box key={index} className="keen-slider__slide" />);
    setFillerSlides(slidesArray);
  };
  const handleFillerDifference = () => {
    const slidesPerView = slider.options().slidesPerView as number;
    if (arrayChildren.length < slidesPerView) {
      const difference = slidesPerView - arrayChildren.length;
      fillSlides(difference);
    } else if (arrayChildren.length >= slidesPerView && fillerSlides.length) {
      setFillerSlides([]);
    }
  };
  useEffect(() => {
    if (slider && getSlider) getSlider(slider);
  }, [slider]);
  useEffect(() => {
    if (slider && fillTrack) {
      handleFillerDifference();
    } else if (slider && !fillTrack) {
      setFillerSlides([]);
    }
    if (slider) slider.resize();
  }, [children]);
  useEffect(() => {
    if (slider) slider.resize();
  }, [fillerSlides]);
  const fullViewStyles = isFullView ? `
    body > div {
      overflow-x: hidden;
    }

    .keen-slider {
      overflow: visible;
    }
  ` : '';
  const overflowVisibleStyles = `
    .keen-slider__slide {
      overflow: visible;
    }
  `;
  return <>
      <style>{`${keenStyles}${fullViewStyles}${overflowVisibleStyles}${overrideStyles}`}</style>
      <Box ref={sliderRef} className="keen-slider" data-sentry-element="Box" data-sentry-source-file="CbCarouselTrack.tsx">
        {wrappedChildren}
        {fillerSlides}
      </Box>
    </>;
};